import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Link as LinkScroll } from 'react-scroll';
import { Col, Container, Row, Card, CardBody, Modal, ModalBody, Button, Offcanvas, OffcanvasBody } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from 'swiper';
import AOS from 'aos';
import Rellax from 'rellax';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'aos/dist/aos.css';

//component
import Header from '../../partials/Header';
import Mempercayai from './Mempercayai';
import Verifikasi from './Verifikasi';
import Quiz from './Quiz';
import Ensiklopedi from '../Ensiklopedi/Index';

//image
import JudulNitijana from '../../assets/images/home/Judul-Nitijana.png';
import RocketNitijana from '../../assets/images/home/rocket-nitijana.png';
import BacaCerita from '../../assets/images/home/btn-baca-cerita.png';
import MulaiGame from '../../assets/images/home/btn-mulai-game.png';
import HoverBacaCerita from '../../assets/images/home/btn-hover-baca-cerita.png';
import HoverMulaiGame from '../../assets/images/home/btn-hover-mulai-game.png';
import MC1 from '../../assets/images/home/MC-1.gif'; 
import MC2 from '../../assets/images/home/MC-2.gif';
import MC3 from '../../assets/images/home/MC-3.gif';
import MC4 from '../../assets/images/home/MC-4.gif';
import SliderChat from '../../assets/images/home/slider-chat.png';
import SliderGame from '../../assets/images/home/slider-game.png';
import SliderMusik from '../../assets/images/home/slider-musik.png';
import SliderNonton from '../../assets/images/home/slider-nonton.png';
import SliderSosmed from '../../assets/images/home/slider-sosmed.png';
import Notification from '../../assets/images/home/notification.png';
import BtnNotification from '../../assets/images/home/btn-notification.png';
import BgChat from '../../assets/images/home/bg-chat.png';
import Chat1 from '../../assets/images/home/chat-1.png';
import Chat2 from '../../assets/images/home/chat-2.png';
import HP1 from '../../assets/images/home/hp-1.png';
import HP2 from '../../assets/images/home/hp-2.png';
import HP3 from '../../assets/images/home/hp-3.png';
import HP4 from '../../assets/images/home/hp-4.png';
import HP5 from '../../assets/images/home/hp-5.png';
import Choose1 from '../../assets/images/home/choose-1.png';
import Choose2 from '../../assets/images/home/choose-2.png';
import UMNWhiteLogo from '../../assets/images/home/umn-white-logo.png';
import Liputan6 from '../../assets/images/home/liputan-6.png';
import NitijanaLogo from '../../assets/images/home/nitijana-logo.png';
import BackToHome from '../../assets/images/home/back-to-home.png';
import CloseModals from '../../assets/images/icons/close-modals.svg';
import Hand from '../../assets/images/home/hand.png';
import ArrowUp from '../../assets/images/icons/arrow-up.svg';
import ArrowDown from '../../assets/images/icons/arrow-down.svg';

SwiperCore.use([Navigation]);

const Index = () => {

  const [modal, setModal] = useState(false);
  const [offCanvas, setOffCanvas] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [scrollElement, setScrollElement] = useState(1);

  let location = useLocation();

  useEffect(() => {
    AOS.init({
      duration: 2000
    });
    var rellax = new Rellax('.rellax');
    if(location.pathname === '/about') {
      window.scrollTo(7300, 7300);
    }    
  }, []);

  const handleModal = (data) => {
    setModal(!modal);
    setModalContent(data);
  }

  const handleModalClose = () => { setModal(!modal); }
  const handleOffCanvas = () => { setOffCanvas(!offCanvas); }

  const welcome = useRef(null);
  const banner = useRef(null);
  const chat = useRef(null);
  const toWelcomeSection = () => welcome.current.scrollIntoView();
  const toBannerSection = () => banner.current.scrollIntoView();
  const toChatSection = () => chat.current.scrollIntoView();

  const about = useRef(null);
  const toAbout = () => about.current.scrollIntoView();

  const navigate = useNavigate()
  const toGame = () => {
    navigate('/game')
  }

  const handleUp = () => {
    if(scrollElement < 1) {
      setScrollElement(1)
    } else {
      setScrollElement(scrollElement - 1)
    }
  }
  const handleDown = () => {
    if(scrollElement > 9) {
      setScrollElement(8)
    } else {
      setScrollElement(scrollElement + 1)
    }
  }

  return (
    <>
      <div className="up-down-button">
        <LinkScroll to={`section-${scrollElement+1}`} onClick={handleDown} className="border-0 bg-transparent up-down-button-scroll">
          <img src={ArrowDown} alt="arrow-down"/>
        </LinkScroll>
        <LinkScroll to={`section-${scrollElement-1}`} onClick={handleUp} className="border-0 bg-transparent up-down-button-scroll">
          <img src={ArrowUp} alt="arrow-up"/>
        </LinkScroll>
      </div>
      <Header scrollAbout={toAbout}/>
      <div className="bg-home-1" ref={banner} id="section-1">
        <Container className="h-100">
          <Row className="h-100">
            <Col md="3" className="text-center my-auto rellax" data-rellax-speed="-2">
              <div className="justify-content-center align-self-center">
                <img src={MC1} alt="mc-1" className="mc-1 img-asset" data-aos={"fade-left"} />
              </div>
            </Col>
            <Col md="6" className="text-center my-auto banner">
              <Row>
                <Col>
                  <img src={JudulNitijana} alt="judul-nitijana" className="img-fluid" />
                  <h1 className="marko-one text-white text-title-home-1">Tangkal Hoaks dengan Cek Fakta</h1>
                  <h6 className="montserrat text-white text-description-home-1 mt-3">
                    Website News Game Nitijana menyajikan teknik sederhana menyaring informasi yang tersebar di media sosial dan internet secara mandiri.
                  </h6>
                </Col>
              </Row>
              <Row className="mt-5 banner-link">
                <Col className="text-center">
                  <button onClick={toWelcomeSection} className="fredoka-one text-white text-link-home-1">
                    <img src={BacaCerita} alt="-baca-cerita" className="img-fluid img-btn-banner" />
                    <img src={HoverBacaCerita} alt="hover-baca-cerita" className="img-fluid img-btn-banner-hover" />
                  </button>
                </Col>
                <Col className="text-center">
                  <button onClick={toGame} className="fredoka-one text-white text-link-home-1">
                    <img src={MulaiGame} alt="-mulai-game" className="img-fluid img-btn-banner" />
                    <img src={HoverMulaiGame} alt="hover-mulai-game" className="img-fluid img-btn-banner-hover" />
                  </button>
                </Col>
              </Row>
            </Col>
            <Col md="3" className="position-relative rellax" data-rellax-speed="3">
              <img src={RocketNitijana} alt="mc-1" className="rocket-nitijana" />
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-home-2" ref={welcome} id="section-2">
        <Container className="h-100">
          <Row className="h-100">
            <Col md="5" className="text-center my-auto position-relative">
              <img src={MC2} alt="mc-2" className="mc-2" data-aos="fade-down" />
            </Col>
            <Col md="7" className="my-auto bg-home-2-content rellax" data-rellax-speed="1">
              <h2 className="marko-one text-light text-title-home-2">Selamat Datang <br/> di Era Digital</h2>
              <p className="montserrat text-light text-description-home-2 mt-4">
                Era penghadiran teknologi yang memudahkanmu menerima dan menyebarkan informasi dengan cepat melalui internet dan media sosial.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-home-3" id="section-3">
        <Container className="h-100">
          <Row className="h-100">
            <Col md="2" className="text-center"></Col>
            <Col md="8" className="text-center mt-5">
              <h2 className="marko-one text-light text-title-home-3">
                Halo, Perkenalkan Aku Rajit!
              </h2>
              <p className="montserrat text-light text-description-home-2 mt-4 mb-5">
                Gen Z berumur 21 tahun, termasuk satu dari 175,5 Juta pengguna internet di Indonesia. Layaknya Gen Z pada umumnya, aku dapat menghabiskan waktu antara 4 hingga 8 jam sehari untuk:
              </p>
              <Swiper
                spaceBetween={30}
                slidesPerView={2.5}
                loop={true}
                navigation={true}
                className="mt-5"
                breakpoints={{
                  991: {
                    slidesPerView: 3,
                  }
                }}
              >
                <SwiperSlide>
                  <img src={SliderChat} alt="slider-chat" className="img-fluid" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={SliderGame} alt="slider-game" className="img-fluid" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={SliderMusik} alt="slider-musik" className="img-fluid" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={SliderNonton} alt="slider-nonton" className="img-fluid" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={SliderSosmed} alt="slider-sosmed" className="img-fluid" />
                </SwiperSlide>
              </Swiper>
            </Col>
            <Col md="2" className="text-center align-text-bottom position-relative" data-aos="fade-right">
              <img src={MC3} alt="mc-3" className="mc-3"/>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-home-3-1">
        <Container>
          <Row>
            <Col>
              <div className="suatu-hari d-flex justify-content-center align-items-center">
                <h2 className="montserrat text-white mb-0">SUATU HARI</h2>
                <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
              </div>
            </Col>
          </Row>
        </Container>
        <Container className="info-notification">
          <Row>
            <Col className='text-center'>
              <span>Rajit mendapat notifikasi pesan masuk dari grup chat keluarga.</span>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-home-4" id="section-4">
        <Container>
          <Row>
            <Col md="5" sm="5" xs="5" className="text-end position-relative">
              <img src={MC4} alt="mc-2" className="mc-4" data-aos="fade-up"/>
            </Col>
            <Col md="7" sm="7" xs="7" className="my-auto text-start notification">
              <div className="position-relative">
                <img src={Notification} alt="notification" className="img-fluid" data-aos="fade-up"/>
                <button onClick={toChatSection} className="border-0 bg-transparent btn-notification">
                  <img src={BtnNotification} alt="btn-notification" data-aos="fade-up" />
                  <img src={Hand} alt="btn-notification" className="hand-button" data-aos="fade-up" />
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-home-5 position-relative" id="section-5" ref={chat}>
        <Container fluid>
          <Row>
            <Col md="3"></Col>
            <Col md="6 text-center img-chat position-relative">
              <img src={BgChat} alt="bg-chat" className="bg-chat img-fluid" />
              <div className="chat-contain">
                <img src={Chat1} alt="chat-1" className="chat-1 img-fluid" data-aos="fade-up"/>
                <img src={Chat2} alt="chat-2" className="chat-2 img-fluid mt-3" data-aos="fade-up"/>
              </div>
            </Col>
            <Col md="3"></Col>
          </Row>
        </Container>
        <h5 className="montserrat mt-5 text-after-chat text-center">Rajit termasuk Gen Z yang <strong>sering menanggapi informasi</strong> yang diterimanya dari keluarga, teman, hingga postingan di media sosial.</h5>
      </div>
      <div className="bg-home-6" id="section-6">
        <Container>
          <Row>
            <Col md="2"></Col>
            <Col md="8" className="text-center">
              <h5 className="montserrat mt-5">Terutama klaim dari <strong>peristiwa yang sedang viral</strong>, seperti: Klaim seputar Covid-19 dan Vaksin Covid-19.</h5>
            </Col>
            <Col md="2"></Col>
            <Col md="12" className="position-relative mt-5 h-100">
              <img src={HP5} alt="HP-5" className="hp hp-5" data-aos="fade-right" data-aos-duration="4000"/>
              <img src={HP4} alt="HP-4" className="hp hp-4" data-aos="fade-right" data-aos-duration="3000"/>
              <img src={HP3} alt="HP-3" className="hp hp-3" data-aos="fade-right" data-aos-duration="2000"/>
              <img src={HP2} alt="HP-2" className="hp hp-2" data-aos="fade-right" data-aos-duration="1000"/>
              <img src={HP1} alt="HP-1" className="hp hp-1" data-aos="fade-right" data-aos-duration="500"/>
            </Col>
            <Col md="2"></Col>
            <Col md="8" className="mt-5 text-center">
              <h5 className="montserrat mt-5 text-5-bottom">Tanpa pikir panjang, beberapa informasi yang baru diterimanya <strong>disebarkan kembali</strong> ke kerabat dan teman-temannya.</h5>
            </Col>
            <Col md="2"></Col>
          </Row>
        </Container>
      </div>
      <div className="bg-home-7" id="section-7">
        <Container className="h-100">
          <Row className="h-100">
            <Col md="12" className="text-center my-auto">
              <p className="montserrat text-white">
                Menanggapi isi chat Tante Rajit di atas,
              </p>
              <h4 className="marko-one text-white">
                Jika berada posisi Rajit, apa yang akan kamu lakukan?
              </h4>
              <Row className="my-5">
                <Col md="2"></Col>
                <Col md="4" className="choosed-question">
                  <img src={Choose2} onClick={handleModal.bind(this, 2)} alt="choose-2" className="w-100" />
                </Col>
                <Col md="4" className="choosed choosed-mobile mt-4">
                  <button onClick={handleModal.bind(this, 1)}>
                    MEMPERCAYAINYA DAN MENYEBARKANNYA
                  </button>
                </Col>
                <Col md="4" className="choosed-question">
                  <img src={Choose1} onClick={handleModal.bind(this, 1)} alt="choose-1" className="w-100" />
                </Col>
                <Col md="4" className="choosed choosed-mobile mt-4">
                  <button onClick={handleModal.bind(this, 2)}>
                    COBA VERIFIKASI INFORMASI DULU
                    <img src={Hand} alt="btn-notification" className="hand-button-2" />
                  </button>
                </Col>
                <Col md="2"></Col>
                <Col md="2"></Col>
                <Col md="4" className="choosed choosed-desktop mt-4">
                  <button onClick={handleModal.bind(this, 1)}>
                    MEMPERCAYAINYA DAN MENYEBARKANNYA
                  </button>
                </Col>
                <Col md="4" className="choosed choosed-desktop mt-4">
                  <button onClick={handleModal.bind(this, 2)}>
                    COBA VERIFIKASI INFORMASI DULU
                    <img src={Hand} alt="btn-notification" className="hand-button-2" />
                  </button>
                </Col>
              </Row>
              <Col md="2"></Col>
              <Col md="12" className="text-center mt-5">
                <p className="montserrat text-white">
                  Klik salah satu teks jawaban di atas untuk melihat penjelasannya.
                </p>
              </Col>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-home-8" id="section-8">
        <Container className="h-100">
          <Row className="h-100">
            <Col md="12" className="mt-5 text-center p-m-auto">
              <Row className="mt-5">
                <Col md="12" className="mb-4">
                  <h6 className="montserrat">
                    Agar tidak terkecoh oleh informasi yang belum pasti, Rajit ingin memperdalam
                    ilmu literasi digital seputar hoaks dan cek fakta...
                    <br /><br />
                    <strong>Yuk, klik salah satu pilihan di bawah ini</strong> untuk melanjutkan perjalananmu!
                  </h6>
                </Col>
                <Col md="6" className="pr-0">
                  <button onClick={handleOffCanvas} className="btn marko-one w-100 btn-choosed">
                    ENSIKLOPEDI<br/>HOAKS
                  </button>
                </Col>
                <Col md="6" className="pr-0">
                  <button onClick={handleModal.bind(this, 3)} className="btn marko-one w-100 btn-choosed">
                    BELAJAR <br/> CEK FAKTA MANDIRI
                  </button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="bg-home-9" ref={about} id="section-9">
        <Container className="h-100">
          <Row className="h-100">
            <Col md="12" className="mt-0 p-m-auto">
              <Card className="card-credits">
                <CardBody className="p-5">
                  <Row>
                    <Col md="6">
                      <div className="credits-group">
                        <h6 className="text-white montserrat title">
                          PRODUSER, STORYBOARD, PENULIS, LIPUTAN, EDITOR KONTEN & VIDEO
                        </h6>
                        <h6 className="text-white montserrat content">
                          Azarine Jovita Halim
                        </h6>
                      </div>
                      <div className="credits-group">
                        <h6 className="text-white montserrat title">
                          ILLUSTRATOR & INTERACTION DESIGNER
                        </h6>
                        <h6 className="text-white montserrat content">
                          Catherine Citta Dewi Maharani
                        </h6>
                      </div>
                      <div className="credits-group">
                        <h6 className="text-white montserrat title">
                          CONCEPT & INTERACTION DESIGNER
                        </h6>
                        <h6 className="text-white montserrat content">
                          Shera Amira Rinaldy
                        </h6>
                      </div>
                      <div className="credits-group">
                        <h6 className="text-white montserrat title">
                          WEB ASSETS DESIGNER
                        </h6>
                        <h6 className="text-white montserrat content">
                          Dyota Akyla Irrangga Yusuf
                        </h6>
                      </div>
                      <div className="credits-group">
                        <h6 className="text-white montserrat title">
                          PROGRAMMER
                        </h6>
                        <h6 className="text-white montserrat content">
                          Sinzie Winata<br/>
                          Denni Irawan
                        </h6>
                      </div>
                      <div className="credits-group credits-group-2">
                        <h6 className="text-white montserrat content">
                          Published: - Desember 2021<br />
                          Copyright © 2021 by Nitijana
                        </h6>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="credits-group">
                        <h6 className="text-white montserrat title">
                          SUPERVISOR
                        </h6>
                        <h6 className="text-white montserrat content">
                          Edu Krisnadefa
                        </h6>
                      </div>
                      <div className="credits-group">
                        <h6 className="text-white montserrat title">
                          DOSEN PEMBIMBING
                        </h6>
                        <h6 className="text-white montserrat content">
                          Taufan Wijaya, S,Sos., M.A.
                        </h6>
                      </div>
                    </Col>
                    <Col md="12" className="d-flex justify-content-between align-items-center">
                      <div className="d-flex justify-content-start align-items-center">
                        <img src={UMNWhiteLogo} alt="umn-white-logo" className="img-credits"/>
                        <img src={Liputan6} alt="liputan-6" className="img-credits mx-3"/>
                      </div>
                      <div className="d-flex justify-content-start align-items-center">
                        <img src={NitijanaLogo} alt="nitijana-logo" className="img-credits mx-3"/>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col md="12" className="position-relative text-end">
              <button onClick={toBannerSection} className="border-0 bg-transparent">
                <img src={BackToHome} alt="back-to-home" className="w-75"/>
              </button>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        isOpen={modal}
        toggle={handleModalClose}
        className={modalContent === 3 ? "modal-home-2 modal-home" : "modal-home"}
      >
        {
          modalContent === 3
          ? <ModalBody className="modal-header-quiz d-flex justify-content-center align-items-center">
              <h3 className="modal-home-quiz-title text-center marko-one mb-0">
                BELAJAR <br/>
                CEK FAKTA MANDIRI
              </h3>
              <Button onClick={handleModalClose} className="border-0 bg-transparent position-absolute close-modals-2" >
                <img src={CloseModals} alt="close-modals" />
              </Button>
            </ModalBody>
          : ''
        }
        <ModalBody className="w-100 pb-0">
          <Row>
            {
              modalContent !== 3
              ? <Col md="12" className="text-end position-relative">
                  <Button onClick={handleModalClose} className="border-0 bg-transparent close-modals" >
                    <img src={CloseModals} alt="close-modals" />
                  </Button>
                </Col>
              : ''
            }
            <Col md="12" className={modalContent === 3 ? "modal-home-content-2" : "modal-home-content"}>
              {
                modalContent === 1 ? (
                  <Mempercayai />
                ) : modalContent === 2 ? (
                  <Verifikasi/>
                ) : modalContent === 3 ? (
                  <Quiz/>
                ) : (
                  ''
                )
              }
            </Col>
            {
              modalContent === 3
                ? <Col md="12" className="text-center mb-5">
                    <Link to={'/game'} onClick={handleModalClose} className="btn btn-lg btn-danger w-75">
                      Main
                    </Link>
                  </Col>
                : ''
            }
          </Row>
         
        </ModalBody>
      </Modal>
      <Offcanvas 
        isOpen={offCanvas}
        toggle={handleOffCanvas}
      >
        <OffcanvasBody>
          <Ensiklopedi closeAction={handleOffCanvas} />
        </OffcanvasBody>
      </Offcanvas>
    </>
  )
}

export default Index;